import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import CloseLesson from '@chegg-tutors-chat/shared/components/Modal/content/CloseLesson/student/CloseLesson';
import { endLesson } from '@chegg-tutors-chat/shared/redux/modules/lessons/actions';
import * as modalActions from '@chegg-tutors-chat/shared/redux/modules/modals/actions';
export function mapStateToProps(_state: GlobalState, passedProps: ModalsState) {
  const { modalOptions } = passedProps;

  return {
    isOpen: true,
    modalOptions
  };
}

export const mapDispatchToProps = (dispatch: Dispatch, passedProps: ModalsState) => {
  const modalOptions = passedProps.modalOptions || {};
  const handleEndLesson = () => {
    dispatch(
      endLesson({
        id: modalOptions.lessonId,
        shouldRedirectToHome: true
      })
    );
  };

  const handleCloseModal = () => {
    dispatch(modalActions.closeModal());
  };

  return {
    primaryButtonClick: handleEndLesson,
    secondaryButtonClick: handleCloseModal
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CloseLesson);
